import React from 'react'
import StatusPill from './StatusPill'

interface PageHeaderProps {
  statusLabel: string
  statusExpired: boolean
  statusActive: boolean
  heading: string
  subHeading: string
}

/** Status pill, page title and supporting line. */
function PageHeader({
  statusLabel,
  statusExpired,
  statusActive,
  heading,
  subHeading,
}: PageHeaderProps) {
  return (
    <div className='mb-6 text-center'>
      <StatusPill
        label={statusLabel}
        expired={statusExpired}
        active={statusActive}
      />
      <h1 className='font-display text-28 font-extrabold tracking-heading text-ink'>
        {heading}
      </h1>
      <p className='mt-2 text-sm text-ink-500'>{subHeading}</p>
    </div>
  )
}

export default PageHeader
